import { dataOrderSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconOrderSolid = /*#__PURE__*/createIcon(dataOrderSolid)
export default IconOrderSolid
